import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

interface SubscriptionGuardProps {
  children: React.ReactNode;
}

const SubscriptionGuard: React.FC<SubscriptionGuardProps> = ({ children }) => {
  const { profile, loading, isSuperAdmin } = useAuth();
  const location = useLocation();

  // Loading state
  if (loading) {
    return <div>Loading...</div>;
  }

  // CRITICAL: Super admin check FIRST - bypasses ALL other checks
  if (isSuperAdmin) {
    return <>{children}</>;
  }

  if (profile?.is_super_admin) {
    return <>{children}</>;
  }

  // Regular user subscription check - allow either Stripe subscription OR enterprise plan
  const organization = (profile as any)?.organizations;
  const hasStripeSubscription = profile?.organization_id && organization?.stripe_subscription_id &&
    (organization?.stripe_subscription_status === 'active' || organization?.stripe_subscription_status === 'trialing');
  const isEnterprisePlan = profile?.organization_id && organization?.plan_type === 'enterprise';
  const isConnectClient = organization?.is_connect_client === true;
  const isActiveOrg = organization?.is_active !== false;

  const hasActiveSubscription = (hasStripeSubscription || isEnterprisePlan || isConnectClient) && isActiveOrg;

  if (!hasActiveSubscription) {
    return <Navigate to="/subscription-required" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default SubscriptionGuard;

export {};
